var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('Header'),_c('div',[_c('section-1'),_c('section-2'),_c('charities'),_c('section-5')],1),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }